export default __webpack_public_path__ + "static/media/Ancient Mace.0e23fa06.jpg";